import { render } from "./GlyueButton.vue?vue&type=template&id=36db000a"
import script from "./GlyueButton.vue?vue&type=script&lang=js"
export * from "./GlyueButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__